import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { candidateRedirect } from "./candidate.guard";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isLoggedIn()) {
    return candidateRedirect() ?? true;
  }

  router.navigate(["/login"]);
  return false;
};
